import { Component } from '@angular/core';

@Component({
  selector: 'app-account-deletion',
  templateUrl: './account-deletion.component.html',
  styleUrls: ['./account-deletion.component.css']
})
export class AccountDeletionComponent {}



// WEBPACK FOOTER //
// ./src/app/public/account-deletion/account-deletion.component.ts